export const PROMPT_FIELD_NAMES = {
  END_OF_CONVERSATION_METADATA_EXTRACTOR:
    'end_of_conversation_metadata_extractor_prompt',
  CONVERSATION_METRICS: 'conversation_metrics_prompt',
  PII_MASKING: 'pii_masking_prompt',
  SYSTEM_PROMPT: 'system_prompt',
  INPROMPT_KNOWLEDGE_BASE: 'inprompt_knowledge_base',
} as const;

export const PROMPT_LABELS = {
  END_OF_CONVERSATION_METADATA_EXTRACTOR:
    'End of Conversation Metadata Extractor',
  CONVERSATION_METRICS: 'Conversation Metrics',
  PII_MASKING: 'PII Masking',
  SYSTEM_PROMPT: 'System Prompt',
  INPROMPT_KNOWLEDGE_BASE: 'Inprompt Knowledge Base',
} as const;

export const PROMPT_FIELDS = [
  {
    name: PROMPT_FIELD_NAMES.END_OF_CONVERSATION_METADATA_EXTRACTOR,
    label: PROMPT_LABELS.END_OF_CONVERSATION_METADATA_EXTRACTOR,
  },
  {
    name: PROMPT_FIELD_NAMES.CONVERSATION_METRICS,
    label: PROMPT_LABELS.CONVERSATION_METRICS,
  },
  {
    name: PROMPT_FIELD_NAMES.PII_MASKING,
    label: PROMPT_LABELS.PII_MASKING,
  },
  {
    name: PROMPT_FIELD_NAMES.SYSTEM_PROMPT,
    label: PROMPT_LABELS.SYSTEM_PROMPT,
  },
  {
    name: PROMPT_FIELD_NAMES.INPROMPT_KNOWLEDGE_BASE,
    label: PROMPT_LABELS.INPROMPT_KNOWLEDGE_BASE,
  },
] as const;
